import request from "axios";
import { apiBase } from "../../constants";
import { DarkVariant, ThemePreference } from "theme/theme";

/**
 * Persist the person's appearance choice on their own record, so it follows
 * them to another browser or computer.
 *
 * Fire-and-forget on purpose: the theme has already been applied locally by the
 * time this runs, and localStorage has already been updated, so a failed save
 * costs the user nothing on this device - it only means the choice will not
 * follow them elsewhere. Blocking the UI or shouting about it would be a worse
 * trade for a colour preference.
 */
export const saveAppearance = async (appearance: {
  themePreference?: ThemePreference;
  darkVariant?: DarkVariant;
}): Promise<boolean> => {
  try {
    await request({
      url: `${apiBase}/v1/team-members/me/appearance`,
      method: "PATCH",
      data: appearance,
      withCredentials: true,
      validateStatus: (status) => status < 300,
    });
    return true;
  } catch (e) {
    // Swallowed on purpose - see above. Reporting false lets the theme manager
    // remember that the server does NOT have this value yet, so it can retry
    // instead of being reverted by the stale one on the next load.
    return false;
  }
};
